// Runtime config injected by Docker via /config.js
// Falls back to build-time env or defaults
const runtimeConfig = (window as any).__ENV__ || {}

export const env = {
  apiBaseUrl: runtimeConfig.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || "http://localhost:3001",
  apiTimeout: Number(runtimeConfig.VITE_API_TIMEOUT || import.meta.env.VITE_API_TIMEOUT) || 30000,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const
